import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/img/auth-background.webp'
import _imports_1 from '../../assets/img/rtlplusz_auth.png'


const _hoisted_1 = {
  id: "main-content",
  style: {"display":"contents"}
}
const _hoisted_2 = {
  key: 0,
  class: "login-backdrop"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "login-backdrop__left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "rtl.hu",
    class: "login-backdrop__left-image"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "login-backdrop__right" }, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "auth auth--login" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "auth__left" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "login-title" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "auth__title" }, "Belépés"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "rtlmost",
      class: "login-title__logo"
    })
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "auth__text" }, "Már van RTL+ regisztrációd? Ide is be tudsz lépni a meglévő adataiddal, nem kell új fiókot létrehoznod.", -1)
const _hoisted_11 = {
  key: 0,
  class: "form-errors"
}
const _hoisted_12 = { class: "form-errors__error" }
const _hoisted_13 = { class: "auth__form-group" }
const _hoisted_14 = { class: "auth__form-group" }
const _hoisted_15 = { class: "auth__form-group auth__row" }
const _hoisted_16 = { class: "auth__col" }
const _hoisted_17 = { class: "auth__col auth__forgot" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Elfelejtettem a jelszavam")
const _hoisted_19 = {
  ref: "loginBtn",
  class: "auth__button auth__button--primary"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "auth__middle" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "auth__middle-text" }, "vagy")
], -1)
const _hoisted_21 = { class: "auth__right" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Belépés Facebook fiókkal ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Belépés Google fiókkal ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Belépés apple fiókkal ")
const _hoisted_25 = { class: "login__bottom" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Még nincs fiókod? ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Regisztrálj!")
const _hoisted_28 = {
  key: 1,
  class: "auth__right"
}
const _hoisted_29 = { class: "login__bottom" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Még nincs fiókod? ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Regisztrálj!")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_social_link_account = _resolveComponent("social-link-account")!
  const _component_social_reg_finish = _resolveComponent("social-reg-finish")!
  const _component_text_input = _resolveComponent("text-input")!
  const _component_password_input = _resolveComponent("password-input")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FacebookFull = _resolveComponent("FacebookFull")!
  const _component_Google = _resolveComponent("Google")!
  const _component_Apple = _resolveComponent("Apple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showLinkModal)
      ? (_openBlock(), _createBlock(_component_social_link_account, {
          key: 0,
          regToken: _ctx.regToken,
          loginID: _ctx.loginID,
          passwordUrl: _ctx.passwordUrl,
          successUrl: _ctx.successUrl
        }, null, 8, ["regToken", "loginID", "passwordUrl", "successUrl"]))
      : _createCommentVNode("", true),
    ((_ctx.showRegFinishModal && _ctx.user))
      ? (_openBlock(), _createBlock(_component_social_reg_finish, {
          key: 1,
          UID: _ctx.user.UID,
          successUrl: _ctx.successUrl
        }, null, 8, ["UID", "successUrl"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showImage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass(["auth__container", { 'auth__container--center': !_ctx.showImage }])
          }, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _hoisted_10,
              _createElementVNode("form", {
                class: "auth__form",
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
              }, [
                (_ctx.hasFieldError('error'))
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                      _createElementVNode("li", _hoisted_12, _toDisplayString(_ctx.getFieldErrorValue('error')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_text_input, {
                    modelValue: _ctx.loginData.loginId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginData.loginId) = $event)),
                    label: "E-mail cím",
                    "error-msg": _ctx.getFieldErrorValue('loginId')
                  }, null, 8, ["modelValue", "error-msg"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_password_input, {
                    modelValue: _ctx.loginData.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginData.password) = $event)),
                    label: "Jelszó",
                    "error-msg": _ctx.getFieldErrorValue('password')
                  }, null, 8, ["modelValue", "error-msg"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_checkbox, {
                      label: "Emlékezz rám",
                      modelValue: _ctx.remember,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.remember) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_router_link, { to: _ctx.passwordUrl }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]),
                _createElementVNode("button", _hoisted_19, "Belépek", 512)
              ], 32)
            ]),
            (!_ctx.socialDisabled)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      "data-social": "facebook",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.socialLogin && _ctx.socialLogin(...args))),
                      class: "auth__button auth__button--facebook"
                    }, [
                      _createVNode(_component_FacebookFull),
                      _hoisted_22
                    ]),
                    _createElementVNode("button", {
                      "data-social": "googleplus",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.socialLogin && _ctx.socialLogin(...args))),
                      class: "auth__button auth__button--google"
                    }, [
                      _createVNode(_component_Google),
                      _hoisted_23
                    ]),
                    _createElementVNode("button", {
                      "data-social": "apple",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.socialLogin && _ctx.socialLogin(...args))),
                      class: "auth__button auth__button--apple"
                    }, [
                      _createVNode(_component_Apple),
                      _hoisted_24
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("p", null, [
                        _hoisted_26,
                        _createVNode(_component_router_link, { to: _ctx.signupUrl }, {
                          default: _withCtx(() => [
                            _hoisted_27
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("p", null, [
                      _hoisted_30,
                      _createVNode(_component_router_link, { to: _ctx.signupUrl }, {
                        default: _withCtx(() => [
                          _hoisted_31
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ])
                ]))
          ], 2)
        ])
      ])
    ])
  ], 64))
}